import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService, NOT_FOUND_PATH } from '@kempower-nx-workspace/receipt-lookup-environment';

@Injectable({ providedIn: 'root' })
/**
 * Centralized route navigation helper for the receipt lookup app.
 * This supports both modes: path parameter (receipt.io/cpo1) and sub domain (cpo1.receipt.io).
 */
export class ReceiptLookupNavigationService {
    readonly #router: Router = inject(Router);
    readonly #config: ConfigService = inject(ConfigService);

    // Navigate to the landing page (search form) root
    navigateToSearchRoot(): void {
        const rootPathSegments = this.#config.isPathParamMode ? ['/', this.#config.extractedCustomerId] : ['/'];
        this.#router.navigate(rootPathSegments);
    }

    // Navigate to the result page after a successful search
    navigateToResult(): void {
        const resultPathsegments = this.#config.isPathParamMode
            ? ['/', this.#config.extractedCustomerId, 'result']
            : ['/', 'result'];
        this.#router.navigate(resultPathsegments);
    }

    // Navigate to not found page (should be handled already by route guard, just in case)
    navigateToNotFound(): void {
        this.#router.navigate(['/', NOT_FOUND_PATH]);
    }
}
